import token, { tokenToVars } from '../token';
import Tabs from './tabs';

export { Tabs };
export default tokenToVars(Tabs, token);
